import React from "react";
import { Card } from "react-bootstrap";
import "./GenericCardSkeletonComponent.css"; // ⬅️ separate CSS file

export const GenericCardSkeletonComponent = ({
  widthClass = "col-md-6",
  circles = 1,
  lines = 3,
  shortEvery = 2,
  cardHeight = 160,
}) => {
  return (
    <div className={`${widthClass} gcs-wrapper`}>
      <Card
        className="gcs-card"
        style={{ minHeight: cardHeight }}
      >
        <Card.Body>
          {/* Circle placeholders */}
          {[...Array(circles)].map((_, i) => (
            <div key={`gcs-circle-${i}`} className="gcs-circle mb-2" />
          ))}

          {/* Line placeholders */}
          {[...Array(lines)].map((_, i) => (
            <div
              key={`gcs-line-${i}`}
              className={`gcs-line ${i % shortEvery === 0 ? "gcs-line-short" : ""}`}
            />
          ))}
        </Card.Body>
      </Card>
    </div>
  );
};
